
const document = {
  state:{
    typeDocument:{},
    data:null,
  },
  mutations:{
    SET_REFUND_TYPE: (state, type) => {
      state.typeDocument = type
    },
    SET_REFUND_DATA: (state, data) => {
      state.data = data
    },
  },
  actions:{
    
  }
}

export default document